import RequireAuthentication from '@/router/guards/RequireAuthentication'
import { lazy } from 'react'

const MyHealthTeam = lazy(() => import('./pages/MyHealthTeam'))
const HealthTeamQuestionnaire = lazy(
  () => import('./pages/HealthTeamQuestionnaire'),
)
const ApsQuestionnaire = lazy(() => import('./pages/ApsQuestionnaire'))

const HealthTeamsRoutes = [
  <RequireAuthentication
    path="/questionario-time-de-saude"
    key="/questionario-time-de-saude"
    exact
    component={HealthTeamQuestionnaire}
  />,

  <RequireAuthentication
    path="/questionario-time-de-saude/questoes"
    key="/questionario-time-de-saude/questoes"
    exact
    component={ApsQuestionnaire}
  />,
  <RequireAuthentication
    path="/questionario-time-de-saude/meu-time"
    key="/questionario-time-de-saude/meu-time"
    exact
    component={MyHealthTeam}
  />,
]

export default HealthTeamsRoutes
